// Lightweight format checks used on the Company step. Kept loose intentionally
// — the goal is to catch obvious typos at the client, not be authoritative.

const EMAIL_RE = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
const ALIAS_RE = /^[a-z0-9.-]+$/;

export function isValidEmail(value) {
  return EMAIL_RE.test((value || "").trim());
}

// Company alias = lowercase letters, numbers, dots and hyphens. Matches the
// helper text shown next to the field on the Company step.
export function isValidAlias(value) {
  return ALIAS_RE.test((value || "").trim());
}

export const MIN_PASSWORD_LENGTH = 8;

export function isValidPassword(value) {
  return (value || "").length >= MIN_PASSWORD_LENGTH;
}
